import { connect } from 'react-redux';
import React from 'react';
import Header from 'presentation/selfService/Header';
import overrideStyle from 'lib/overrideStyle';

import AnswerDisplay from './AnswerDisplay';
import ChatWithAgentButton from './ChatWithAgentButton';
import { getSelectedSelfServiceAnswer, getCurrentLocation } from 'app/modules';
import { LOCATIONS } from 'app/modules/ui/constants';
import OfficeHourDisplay from './OfficeHourDisplay';
import Search from 'presentation/selfService/Search';
import QuickActions from './QuickActions';

import { getBorder, getBorderRadius, getColors, getDropshadowEnabled, getFont, getSelfService } from 'app/modules';

const Wrapper = overrideStyle('div')`
  background-color: white;
  border-radius: 10px;
  box-shadow: inherit;
  display: flex;
  flex-direction: column;
  height: 575px;
  max-height: calc(100vh - 30px);
  justify-content: flex-end;
  overflow: hidden;
  top: 0px;
  width: 364px;
`;

const Content = overrideStyle('div')`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 0 24px;
`;

export function SelfService(props) {
  const {
    searchPlaceholder,
    chatWithAgentButtonText,
    headerTitle,
    officeHourMessage,
    quickActions,
  } = props.selfServiceCustomization;

  let content;
  let shouldDisplayBackButton = false;

  if (props.currentLocation === LOCATIONS.OFFICE_HOURS) {
    content = <OfficeHourDisplay message={officeHourMessage} />;
    shouldDisplayBackButton = true;
  } else if (props.currentLocation === LOCATIONS.ANSWER) {
    content = <AnswerDisplay />;
    shouldDisplayBackButton = true;
  } else {
    content = (
      <Search
        defaultContent={<QuickActions theme={props.theme} quickActions={quickActions} />}
        placeholder={searchPlaceholder}
      />
    );
  }

  return (
    <Wrapper theme={props.theme}>
      <Content>
        <Header theme={props.theme} title={headerTitle} shouldDisplayBackButton={shouldDisplayBackButton} />
        {content}
      </Content>
      {props.currentLocation !== LOCATIONS.OFFICE_HOURS ? (
        <ChatWithAgentButton theme={props.theme} buttonText={chatWithAgentButtonText} />
      ) : null}
    </Wrapper>
  );
}

const mapStateToProps = state => {
  return {
    currentLocation: getCurrentLocation(state),
    theme: {
      border: getBorder(state),
      borderRadius: getBorderRadius(state),
      colors: getColors(state),
      dropshadowEnabled: getDropshadowEnabled(state),
      font: getFont(state),
    },
    selfServiceCustomization: getSelfService(state),
  };
};

export default connect(mapStateToProps)(SelfService);
